module.exports = __webpack_public_path__ + "406e51c67919bbf90f29dae225844f03.MP3";